export const FIRESTORE_TABLELINKS_COLLECTION = "tablelinks";
export const FIRESTORE_TABLES_COLLECTION = "tables";